module.exports = __webpack_public_path__ + "img/thumb-jay-off.cea491d9.jpg";